import React from 'react';
import { AssetStoryblok } from '../../../../../types/storyblok';
import isDarkColour from '../../../../../utils/isDarkColour';
import { Type } from '../../../../../base/Type/Type';
import { Box } from '../../../../../base/Box/Box';

type Props = {
  message?: string;
  colourScheme: 'dark' | 'darkGreen' | string;
  lightIcon?: AssetStoryblok;
  darkIcon?: AssetStoryblok;
};

const getIconSource = ({ colourScheme, lightIcon, darkIcon }: Props) => {
  const hasLightIcon = !!lightIcon;
  const hasDarkIcon = !!darkIcon;
  const hasBothIcons = hasLightIcon && hasDarkIcon;
  const isDarkColourScheme = isDarkColour(colourScheme);

  if (hasBothIcons) {
    return isDarkColourScheme ? lightIcon : darkIcon;
  } else if (hasDarkIcon) {
    return darkIcon;
  } else if (hasLightIcon) {
    return lightIcon;
  } else {
    return null;
  }
};

export const AddOn = (props: Props) => {
  if (!props.message) {
    return null;
  }

  const iconSource = getIconSource(props);

  return (
    <Box as="div" className="flex items-center gap-2">
      {!!iconSource && <img src={iconSource.filename} className="w-3" />}
      <Type as="p">{props.message}</Type>
    </Box>
  );
};
